import { useEffect, type ReactNode } from 'react'
import { cn } from '@/lib/utils'
import { useUIStore } from '@/stores/useUIStore'
import { ManagerSidebar } from './ManagerSidebar'
import { useManagerNavigation } from './useManagerNavigation'
import { OutboundSuspendedBanner } from './OutboundSuspendedBanner'
import { MobileBrowserSplash } from '@/components/MobileBrowserSplash'

interface Props {
  children: ReactNode
}

export function ManagerLayout({ children }: Props) {
  const darkMode = useUIStore((s) => s.darkMode)
  const { activeTab, setActiveTab } = useManagerNavigation()

  useEffect(() => {
    document.documentElement.classList.toggle('dark', darkMode)
  }, [darkMode])

  return (
    <div
      className={cn(
        'h-screen flex overflow-hidden',
        darkMode ? 'bg-slate-900 text-slate-100' : 'bg-slate-50 text-slate-900',
      )}
    >
      <ManagerSidebar activeTab={activeTab} onTabChange={setActiveTab} />

      <div className="flex-1 flex flex-col min-w-0 min-h-0">
        {/* Bannière : sortant en retard/suspendu pour impayé (ne s'affiche que si concerné) */}
        <OutboundSuspendedBanner />
        <main className="flex-1 min-h-0 overflow-hidden">{children}</main>
      </div>

      <MobileBrowserSplash />
    </div>
  )
}
